import { createInertiaApp, type ResolvedComponent } from '@inertiajs/react'
import { type ReactNode, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'

const noLayoutPages = ['sessions/', 'registrations/', 'passwords/', 'landing/', 'backstage/', 'public_kegs/anonymous', 'organizations/new']

void createInertiaApp({
  title: (title) => (title ? `${title} - Solution de gestion de fûts pour les brasseries artisanales` : 'Solution de gestion de fûts pour les brasseries artisanales'),

  resolve: (name) => {
    const pages = import.meta.glob<{ default: ResolvedComponent }>('../pages/**/*.tsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
    }

    const isAuthPage = noLayoutPages.some((prefix) => name.startsWith(prefix))
    if (!isAuthPage) {
      page.default.layout ||= (page: ReactNode) => (
        <AuthenticatedLayout>{page}</AuthenticatedLayout>
      )
    }

    return page
  },

  setup({ el, App, props }) {
    createRoot(el).render(
      <StrictMode>
        <App {...props} />
      </StrictMode>,
    )
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
    },
    future: {
      useScriptElementForInitialPage: true,
      useDataInertiaHeadAttribute: true,
      useDialogForErrorModal: true,
      preserveEqualProps: true,
    },
  },
}).catch((error) => {
  if (document.getElementById('app')) {
    throw error
  } else {
    console.error(
      'Missing root element.\n\n' +
        'If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n' +
        'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
